import { PagedSingleSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { yasumiProviderService } from "./yasumiProviderService";

interface Props {
	name: string;
	label: string;
	clearable?: boolean;
	required?: boolean;
	disabled?: boolean;
}

const fetchConfig = laravelSelectFetchConfig(yasumiProviderService.baseKey, (search, page) =>
	yasumiProviderService.index(search, page).then((r) => r.data),
);

export const YasumiProviderSelect: FC<Props> = ({ name, label, clearable, required, disabled }) => {
	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			getLabel={(o) => o.label}
			clearable={clearable}
			required={required}
			disabled={disabled}
			fetchConfig={fetchConfig}
		/>
	);
};
